import { render, staticRenderFns } from "./HorizontalListGroup.vue?vue&type=template&id=422b5fdd"
import script from "./HorizontalListGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports